<template>
  <div id="SatelliteImagery">
  <section class="con3" :class="{on:classActive}">
    <div class="con3_bg"><img src="../../assets/image/con3_2.png"></div>
    <figure>
      <h3 class="con3_1" data-lang="con_title_satellite_imagery">Satellite Imagery Pre-Processing</h3>
      <p class="con3_2" data-lang="con_sub_title_satellite_imagery">Satellite image data received from the ground station can only be used after being processed.</p>
      <p class="con3_3" data-lang="con_text_satellite_imagery">The pre-processing of satellite imageries include radiometric correction, atmospheric correction, orthorectification, geometric correction, etc., and the data can be processed at varying levels depending on the purpose. These levels range from 0 to 4. Level-0 data means the unprocessed raw data acquired directly from the satellite sensor which are not distributed before some fundamental processing. Data then can undergo various stages of corrections corresponding to the Level-1(A,B,C) and Level-2, and further to Level-3 and -4 if necessary. Customers who purchase satellite imageries mainly apply deep learning-based techniques such as object detection and change detection to create value-added services in different areas required by the end-users.</p>
    </figure>
  </section>
  </div>
</template>

<script>
import $ from "jquery"

export default {
  name: "SatelliteImagery",
  data: ()=> ({
    myScroll: null,
    classActive: false,
  }),
  props: ['nowScroll'],
  watch: {
    nowScroll(newData) {
      this.textToggle(newData)
    }
  },
  mounted() {
    this.myScroll = $('#SatelliteImagery').offset().top
  },
  methods: {
    textToggle(data) {
      if(data >= (this.myScroll - 600)) {
        this.classActive = true
      } else {
        this.classActive = false
      }
    }
  }
}
</script>

<style scoped>

</style>